import { User, UserStatus } from "@/types";
import { Chip, ChipProps } from "@mui/material";
import { FC } from "react";
import { sanitizeFieldRestProps, useRecordContext } from "react-admin";
import { StatusFieldProps } from "./status-field.types";
import { formatUserStatus } from "@/utils";

const chipColorByStatus = (status: UserStatus): ChipProps["color"] => {
  switch (status) {
    case UserStatus.PENDING: {
      return "warning";
    }
    case UserStatus.REJECTED: {
      return "error";
    }
  }
};

const StatusField: FC<StatusFieldProps> = (props) => {
  const user = useRecordContext<User>();

  if (!user) return null;

  return (
    <Chip
      size="small"
      variant="outlined"
      color={chipColorByStatus(user.status)}
      label={formatUserStatus(user.status)}
      {...sanitizeFieldRestProps(props)}
    />
  );
};

export { StatusField };
